// Shared LoyaltyLion tier helpers for the account-banner and points-and-tier
// sections. The SDK sets window.loyaltylion before customer data lands, so we
// poll the data, not the element. Bounds and eligible spend are in pence.

window.LoyaltyTier = window.LoyaltyTier || (function () {
  function whenReady(timeoutMs) {
    var timeout = timeoutMs || 8000;
    return new Promise(function (resolve, reject) {
      var started = Date.now();
      (function check() {
        var lion = window.loyaltylion;
        if (lion && lion.customer && lion.program) return resolve(lion);
        if (Date.now() - started >= timeout) return reject(new Error('LoyaltyLion did not load in time'));
        setTimeout(check, 150);
      })();
    });
  }

  function lowerBound(tier) {
    return (tier && tier.bounds && Number(tier.bounds.lower)) || 0;
  }

  function orderedTiers(lion) {
    var tiers = (lion && lion.program && lion.program.loyaltyTiers) || [];
    return tiers.slice().sort(function (a, b) { return lowerBound(a) - lowerBound(b); });
  }

  // Index of the customer's current tier within orderedTiers. Prefer LL's own
  // membership id; fall back to ranking by rolling eligible spend; else lowest.
  function currentIndex(lion, ordered) {
    var tiers = ordered || orderedTiers(lion);
    var membership = (lion.customer && lion.customer.loyaltyTierMembership) || {};
    var byId = tiers.findIndex(function (t) { return t.id == membership.loyaltyTierId; });
    if (byId > -1) return byId;

    var spend = lion.customer && lion.customer.loyaltyTierEligibleSpend;
    if (typeof spend === 'number' && !Number.isNaN(spend)) {
      var idx = 0;
      for (var i = 0; i < tiers.length; i++) {
        if (spend >= lowerBound(tiers[i])) idx = i;
      }
      return idx;
    }
    return 0;
  }

  return {
    whenReady: whenReady,
    orderedTiers: orderedTiers,
    currentIndex: currentIndex,
    lowerBound: lowerBound
  };
})();
